<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <!-- 7 -->
    <input-form-penilaian
      :tables="tableInput.inputForm1"
      :listInput="listInput.inputForm1"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview"
    />
    <desc-penilaian
      :tables="tableDesc.inputForm1"
      :listInput="listDesc.inputForm1"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
    />
    <block-label :label="'7. SERTIFIKASI SISTEM MANAJEMEN'" />
    <plain-label
      :label="
        'Berikan keterangan rinci mengenai Sistem Manajemen K3L dan Operasional di perusahaan anda yang sudah mendapatkan sertifikasi atau dinilai/audit oleh pihak ketiga yang terdaftar di badan Akreditasi Nasional/Internasional'
      "
    />
    <div class="vendor-form-wrapper">
      <input-fill-form
        :label="'Sistem Manajemen'"
        :tables="[
          {
            name: 'Sistem Menajemen/Lingkup Audit',
            obj_name: 'lingkup_audit',
            css: 'column20 mr10 all-column',
            input: false,
            type: '',
          },
          {
            name: 'Organisasi Pihak Ketiga (Lembaga Penerbit Sertifikasi)',
            obj_name: 'third_party',
            css: 'column15 mr10 all-column',
            input: false,
            type: '',
          },
          {
            name: 'Masa Berlaku',
            obj_name: 'masa_berlaku',
            css: 'column10 mr10',
            input: false,
            type: '',
          },
          {
            name: 'Tanggal Efektif',
            obj_name: 'tgl_efektif',
            css: 'column10 mr10',
            input: false,
            type: '',
          },
          {
            name: 'Tangga Berakhir',
            obj_name: 'tgl_berakhir',
            css: 'column15 mr10',
            input: false,
            type: '',
          },
          {
            name: 'Sertifikat',
            obj_name: 'sertifikasi',
            css: 'column15 mr10 all-column',
            input: false,
            type: 'file',
          },
        ]"
        :isRequired="false"
        :modalName="'modal_add_sistem_manajemen'"
        :modelName="'addedSistemManajemen'"
        :mutationName="'k3lStore/SET_K3L_FORM'"
        :storeName="'k3lStore'"
        :operationAdd="'manage_add'"
        :editMutation="'k3lStore/SET_SISTEM_MANAJEMEN'"
        :disabled="true"
      />
    </div>
    <plain-label
      :label="
        'Lampirkan daftar dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir)'
      "
    />
    <upload-file
      :modelName="'daftarDokumenKerja'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="25"
    />
    <plain-label
      :label="
        'Lampirkan dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir)'
      "
    />
    <upload-file
      :modelName="'dokumenKerja'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="26"
    />
    <plain-label
      :label="
        'Lampirkan bukti Pemerikasaan implementasi dokumen kerja (contoh: catatan inspeksi, catatan observasi, catatan hazard report, catatan coaching, dll)'
      "
    />
    <upload-file
      :modelName="'pemeriksaanImpelentasiDokumenKerja'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="27"
    />

    <!-- 8 -->
    <input-form-penilaian
      :tables="tableInput.inputForm2"
      :listInput="listInput.inputForm2"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
      :disabled="$store.state.k3lStore.is_preview"
    />
    <desc-penilaian
      :tables="tableDesc.inputForm2"
      :listInput="listDesc.inputForm2"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
    />
    <block-label :label="'8. KINERJA K3L'" />
    <plain-label
      :label="
        `Berikan penjelasan rinci mengenai Kinerja K3L serta statistik untuk kerja keselamatan (angka Frequency Rates 'FR' per 1,000,000 jam kerja). *Jumlah kecelakaan berdampak fatality (FT), Major, Minor Injuries, Medical Treatment Injury (MTI), Restricted Working Injury (RWI), First Aid (FA)  `
      "
    />
    <input-area
      :storeName="'k3lStore'"
      :modelName="'textGroup8'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true"
    />
    <plain-label
      :label="
        'Lampirkan informasi statistik kinerja K3L serta statistik untuk kerja keselamatan selama 3 Tahun terakhir '
      "
    />
    <upload-file
      :modelName="'statistikKinerjaK3L'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="28"
    />
    <plain-label
      :label="
        'Berikan penjelasan bila perusahaan mengalami kecelakaan berdampak LTI (Lost Time Injury) atau pelanggaran lingkungan akibat dari tindakan Perusahaan, Sub-kontraktor anda atau orang lain yang bertindak atas nama Perusahaan anda selama 3 tahun terakhir'
      "
    />
    <input-area
      :storeName="'k3lStore'"
      :modelName="'textGroup82'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :disabled="true"
    />
    <plain-label :label="'Lampirkan laporan penyelidikan kecelakaan'" />
    <upload-file
      :modelName="'penyelidikanKecelakaan'"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :disabled="true"
      :docId="29"
    />

    <block-label :label="'HASIL PENILAIAN TOTAL'" />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 text-bold',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css:
            'column30 col-nohover bg-transparent border-0 text-center text-bold',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          head: [
            {
              title_1: 'MODUL',
              title_2: 'BOBOT NILAI',
              title_3: 'NILAI',
            },
          ],
          item: [
            {
              type: 'desc',
              desc_1: ['DOKUMEN PERIZINAN PERUSAHAAN'],
              desc_2: ['20%'],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <!-- IUJP -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['IUJP / SIUP'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1', 'ITEM 1.2'],
              desc_2: [bobot_1_1, bobot_1_2],
              desc_3: [value_1_1, value_1_2],
            },
          ],
        },
      ]"
    />

    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 text-bold',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css:
            'column30 col-nohover bg-transparent border-0 text-center text-bold',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['SUMBER DAYA MANUSIA DAN KOMPETENSI'],
              desc_2: ['15%'],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <!-- KOMPETENSI UMUM -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['KOMPETENSI UMUM'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1'],
              desc_2: [bobot_2_1],
              desc_3: [value_2_1],
            },
          ],
        },
      ]"
    />
    <!-- KOMPETENSI KHUSUS -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['KOMPETENSI KHUSUS'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1', 'ITEM 1.2'],
              desc_2: [bobot_2_2, bobot_2_3],
              desc_3: [value_2_2, value_2_3],
            },
          ],
        },
      ]"
    />

    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 text-bold',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css:
            'column30 col-nohover bg-transparent border-0 text-center text-bold',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['PENGELOLAAN K3L'],
              desc_2: ['65%'],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <!-- KEBIJAKAN KEPEMIMPINAN & KOMITMEN -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['KEBIJAKAN KEPEMIMPINAN & KOMITMEN'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1'],
              desc_2: [bobot_3_1],
              desc_3: [value_3_1],
            },
          ],
        },
      ]"
    />
    <!-- MANAJEMEN RESIKO -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['MANAJEMEN RESIKO'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1', 'ITEM 1.2'],
              desc_2: [bobot_3_2, bobot_3_3],
              desc_3: [value_3_2, value_3_3],
            },
          ],
        },
      ]"
    />
    <!-- MANUAL K3L -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['MANUAL K3L'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1'],
              desc_2: [bobot_3_4],
              desc_3: [value_3_4],
            },
          ],
        },
      ]"
    />
    <!-- PENGELOLAAN B3 -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['PENGELOLAAN B3'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1'],
              desc_2: [bobot_3_5],
              desc_3: [value_3_5],
            },
          ],
        },
      ]"
    />
    <!-- PENGELOLAAN LIMBAH -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['PENGELOLAAN LIMBAH'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1'],
              desc_2: [bobot_3_6],
              desc_3: [value_3_6],
            },
          ],
        },
      ]"
    />
    <!-- PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES) -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['PENCEGAHAN KECELAKAAN FATAL (GOLDEN RULES)'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1', 'ITEM 1.2'],
              desc_2: [bobot_3_7, bobot_3_8],
              desc_3: [value_3_7, value_3_8],
            },
          ],
        },
      ]"
    />
    <!-- SERTIFIKASI MANAJEMEN -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['SERTIFIKASI MANAJEMEN'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1', 'ITEM 1.2'],
              desc_2: [bobot_3_9, bobot_3_10],
              desc_3: [value_3_9, value_3_10],
            },
          ],
        },
      ]"
    />
    <!-- KINERJA K3L -->
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['KINERJA K3L'],
              desc_2: [],
              desc_3: [],
            },
          ],
        },
      ]"
    />
    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css: 'column40 col-nohover bg-transparent border-0 px-5',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css: 'column30 col-nohover bg-transparent border-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: ['ITEM 1.1'],
              desc_2: [bobot_3_11],
              desc_3: [value_3_11],
            },
          ],
        },
      ]"
    />

    <desc-penilaian
      :tables="[
        {
          title: 'title_1',
          desc: 'desc_1',
          css:
            'column40 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0',
        },
        {
          title: 'title_2',
          desc: 'desc_2',
          css:
            'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0 text-center',
        },
        {
          title: 'title_3',
          desc: 'desc_3',
          css:
            'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0 text-center',
        },
      ]"
      :listInput="[
        {
          item: [
            {
              type: 'desc',
              desc_1: [''],
              desc_2: ['Total Nilai'],
              desc_3: [
                `${this.total_result} - ${k3lKplhCategory(
                  this.total_result > 0 ? this.total_result : 0
                )}`,
              ],
            },
          ],
        },
      ]"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'k3lStore/SET_K3L_FORM'"
      :storeName="'k3lStore'"
      :modalName="'modal_add_iujp'"
    />

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Simpan & Lanjutkan
      </div>
    </div>
  </div>
</template>

<script>
import InputArea from '../../components/forms/input/input-area.vue'
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import PlainLabel from '../../components/forms/label/plainLabel.vue'
import UploadFile from '../../components/forms/input/multiple_upload.vue'
import InputFillForm from '../../components/forms/input-fill-form.vue'
import InputFormPenilaian from '../../components/forms/input-form-penilaian.vue'
import DescPenilaian from '../../components/desc-penilaian.vue'
export default {
  components: {
    BlockLabel,
    PlainLabel,
    InputArea,
    UploadFile,
    InputFillForm,
    InputFormPenilaian,
    DescPenilaian,
  },
  data() {
    return {
      tableInput: {
        inputForm1: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
        inputForm2: [
          {
            name: 'ASSESOR PENGELOLAAN K3L',
            obj_name: 'jenis',
            css: 'column40 mr10',
            input: false,
            type: 'name',
          },
          {
            name: 'BOBOT (65%)',
            obj_name: 'bidang',
            css: 'column10',
            input: false,
            type: 'subname',
          },
          {
            name: 'NILAI',
            obj_name: 'sub_bidang',
            css: 'column10',
            input: true,
            type: 'select',
          },
          {
            name: 'CATATAN',
            obj_name: 'sub_bidang',
            css: 'column40',
            input: true,
            type: 'text',
          },
        ],
      },
      listInput: {
        inputForm1: [
          {
            type: 'label',
            label: 'SERTIFIKASI SISTEM MANAGEMEN',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup7_11',
            inputStore: 'note_grup7_11',
          },
          {
            type: 'form',
            name: 'ITEM 1.2',
            subname: '15.4%',
            options: ['N/A', '0', '5', '10'],
            optionStore: 'penilaian_grup7_12',
            inputStore: 'note_grup7_12',
          },
        ],
        inputForm2: [
          {
            type: 'label',
            label: 'KINERJA K3L',
          },
          {
            type: 'form',
            name: 'ITEM 1.1',
            subname: '7.70%',
            options: ['N/A', '0', '3', '5'],
            optionStore: 'penilaian_grup8_11',
            inputStore: 'note_grup8_11',
          },
        ],
      },
      tableDesc: {
        inputForm1: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
        inputForm2: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css: 'column20 col-nohover',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css: 'column30 col-nohover',
          },
          {
            title: 'title_4',
            desc: 'desc_4',
            css: 'column30 col-nohover',
          },
        ],
        inputForm3: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css:
              'column40 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css:
              'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0 text-center',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css:
              'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0 text-center',
          },
        ],
        inputForm4: [
          {
            title: 'title_1',
            desc: 'desc_1',
            css:
              'column40 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0',
          },
          {
            title: 'title_2',
            desc: 'desc_2',
            css:
              'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0',
          },
          {
            title: 'title_3',
            desc: 'desc_3',
            css:
              'column30 col-nohover bg-transparent border-left-0 border-bottom-0 border-right-0 text-center',
          },
        ],
      },
      listDesc: {
        inputForm1: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'SERTIFIKASI SISTEM MANAJEMEN',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2:
                  'Tidak ada Sistem Manajemen K3L dan Operasional (manual/prosedur/standar/dll).',
                desc_3: [
                  '1. Memiliki daftar dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir).',
                ],
                desc_4: [
                  '1. Memiliki daftar dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir).',
                  '2. Memiliki dokumen kerja (pedoman, prosedur, standar, instruksi kerja, formulir).',
                  '3. Bukti pemeriksaan implementasi dokumen kerja (contoh: catatan inspeksi, catatan observasi, catatan hazard report, catatan coaching, dll',
                ],
              },
            ],
          },
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '5',
                title_4: '10',
              },
            ],
            item: [
              {
                type: 'desc',
                desc_1: 'ITEM 1.2',
                desc_2:
                  '1. Tidak memiliki sertifikasi Sistem Manajemen K3L dan Operational(ISO 14001/ISO 45001/ISO 9001/SMK3L/SMKP, dll).',
                desc_3: [
                  '1. Memiliki sertifikasi Sistem Manajemen K3L dan Operational(ISO 14001/ISO 45001/ISO 9001/SMK3L/SMKP, dll).',
                  '2. Sertifikasi Sistem Manajemen K3L dan Operational dikeluarkan oleh badan sertifikasi yang terdaftar di Badan Akreditasi Nasional/International.',
                ],
                desc_4: [
                  '1. Memiliki sertifikasi Sistem Manajemen K3L dan Operational(ISO 14001/ISO 45001/ISO 9001/SMK3L/SMKP, dll).',
                  '2. Sertifikasi Sistem Manajemen K3L dan Operational dikeluarkan oleh badan sertifikasi yang terdaftar di Badan Akreditasi Nasional/International.',
                  '3. Semua sertifikasi Sistem Manajemen K3L dan Operational masih berlaku.',
                ],
              },
            ],
          },
        ],
        inputForm2: [
          {
            head: [
              {
                title_1: 'BOBOT NILAI',
                title_2: '0',
                title_3: '3',
                title_4: '5',
              },
            ],
            item: [
              {
                type: 'label',
                label: 'KINERJA K3L',
              },
              {
                type: 'desc',
                desc_1: 'ITEM 1.1',
                desc_2: [
                  '1. Tidak terdapat informasi statistik kinerja K3L serta statistik unjuk kerja keselamatan yang memadai.',
                  '2. Terdapat kecelakaan kerja berdampak LTI atau pelanggaran lingkungan dalam 3 tahun terakhir.',
                ],
                desc_3: [
                  '1. Terdapat informasi statistik kinerja K3L serta statistik unjuk kerja keselamatan dalam 3 tahun terakhir.',
                  '2. Tidak terdapat kecelakaan kerja berdampak LTI atau pelanggaran lingkungan dalam 3 tahun terakhir.',
                ],
                desc_4: [
                  '1. Terdapat informasi statistik kinerja K3L serta statistik unjuk kerja keselamatan dalam 3 tahun terakhir.',
                  '2. Tidak terdapat kecelakaan kerja berdampak LTI atau pelanggaran lingkungan dalam 3 tahun terakhir.',
                  '3. Prestasi dari hasil pemantauan kinerja K3L dari pemerintah atau perusahaan induk (Proper biru, hijau, emas, zero accident award, safe manhour award, dll).',
                ],
              },
            ],
          },
        ],
        inputForm3: [
          {
            head: [
              {
                title_1: 'MODUL',
                title_2: 'BOBOT NILAI',
                title_3: 'NILAI',
              },
            ],
            item: [
              {
                type: 'desc',
                desc_1: [
                  'DOKUMEN PERIZINAN PERUSAHAAN',
                  'SUMBER DAYA MANUSIA DAN KOMPETENSI',
                  ,
                  'PENGELOLAAN K3L',
                ],
                desc_2: ['20%', '15%', '65%'],
                desc_3: [
                  this.rating_result_1,
                  this.rating_result_2,
                  this.rating_result_3,
                ],
              },
            ],
          },
        ],
        inputForm4: [
          {
            item: [
              {
                type: 'desc',
                desc_1: [''],
                desc_2: [''],
                desc_3: [this.total_result],
              },
            ],
          },
        ],
      },
    }
  },
  async created() {
    const route = this.$route.path
    await this.$store.commit('k3lStore/CALCULATION_1')
    await this.$store.commit('k3lStore/CALCULATION_2')
    await this.$store.commit('k3lStore/CALCULATION_3')
  },
  computed: {
    rating_result_1() {
      return this.$store.state.k3lStore.rating_result_1
    },
    rating_result_2() {
      return this.$store.state.k3lStore.rating_result_2
    },
    rating_result_3() {
      return this.$store.state.k3lStore.rating_result_3
    },
    total_result() {
      return this.$store.state.k3lStore.total_result
    },
    bobot_1_1() {
      const value = this.$store.state.k3lStore.bobot_1_1
      return value
    },
    bobot_1_2() {
      const value = this.$store.state.k3lStore.bobot_1_2
      return value
    },
    bobot_2_1() {
      const value = this.$store.state.k3lStore.bobot_2_1
      return value
    },
    bobot_2_2() {
      const value = this.$store.state.k3lStore.bobot_2_2
      return value
    },
    bobot_2_3() {
      const value = this.$store.state.k3lStore.bobot_2_3
      return value
    },
    bobot_3_1() {
      const value = this.$store.state.k3lStore.bobot_3_1
      return value
    },
    bobot_3_2() {
      const value = this.$store.state.k3lStore.bobot_3_2
      return value
    },
    bobot_3_3() {
      const value = this.$store.state.k3lStore.bobot_3_3
      return value
    },
    bobot_3_4() {
      const value = this.$store.state.k3lStore.bobot_3_4
      return value
    },
    bobot_3_5() {
      const value = this.$store.state.k3lStore.bobot_3_5
      return value
    },
    bobot_3_6() {
      const value = this.$store.state.k3lStore.bobot_3_6
      return value
    },
    bobot_3_7() {
      const value = this.$store.state.k3lStore.bobot_3_7
      return value
    },
    bobot_3_8() {
      const value = this.$store.state.k3lStore.bobot_3_8
      return value
    },
    bobot_3_9() {
      const value = this.$store.state.k3lStore.bobot_3_9
      return value
    },
    bobot_3_10() {
      const value = this.$store.state.k3lStore.bobot_3_10
      return value
    },
    bobot_3_11() {
      const value = this.$store.state.k3lStore.bobot_3_11
      return value
    },

    value_1_1() {
      const value = this.$store.state.k3lStore.value_1_1
      return value
    },
    value_1_2() {
      const value = this.$store.state.k3lStore.value_1_2
      return value
    },
    value_2_1() {
      const value = this.$store.state.k3lStore.value_2_1
      return value
    },
    value_2_2() {
      const value = this.$store.state.k3lStore.value_2_2
      return value
    },
    value_2_3() {
      const value = this.$store.state.k3lStore.value_2_3
      return value
    },

    value_3_1() {
      const value = this.$store.state.k3lStore.value_3_1
      return value
    },
    value_3_2() {
      const value = this.$store.state.k3lStore.value_3_2
      return value
    },
    value_3_3() {
      const value = this.$store.state.k3lStore.value_3_3
      return value
    },
    value_3_4() {
      const value = this.$store.state.k3lStore.value_3_4
      return value
    },
    value_3_5() {
      const value = this.$store.state.k3lStore.value_3_5
      return value
    },
    value_3_6() {
      const value = this.$store.state.k3lStore.value_3_6
      return value
    },
    value_3_7() {
      const value = this.$store.state.k3lStore.value_3_7
      return value
    },
    value_3_8() {
      const value = this.$store.state.k3lStore.value_3_8
      return value
    },
    value_3_9() {
      const value = this.$store.state.k3lStore.value_3_9
      return value
    },
    value_3_10() {
      const value = this.$store.state.k3lStore.value_3_10
      return value
    },
    value_3_11() {
      const value = this.$store.state.k3lStore.value_3_11
      return value
    },
  },
  watch: {
    '$store.state.k3lStore.penilaian_grup7_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup7_12'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
    '$store.state.k3lStore.penilaian_grup8_11'(value, oldValue) {
      this.$store.commit('k3lStore/CALCULATION_3')
    },
  },
  methods: {
    goBack() {
      this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'grup46' })
    },
    goNext() {
      if (this.$get(this.$store, 'state.k3lStore.is_preview')) {
        this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'selesai' })
      } else {
        this.$store.commit('k3lStore/SAVE_DRAFT_SIPM_SUBMIT', {
          onSuccess: () => {
            this.$store.commit('k3lStore/SET_ACTIVE_PAGE', { name: 'selesai' })
          },
        })
      }
    },
    k3lKplhCategory(score) {
      if (typeof score == 'number') {
        if (score <= 20) return 'LOW C2'
        if (score > 21 && score <= 35) return 'LOW C1'
        if (score > 35 && score <= 50) return 'MEDIUM B2'
        if (score > 50 && score <= 80) return 'MEDIUM B1'
        if (score > 80 && score <= 100) return 'HIGH A'
      }
      return '-'
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
